import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
var _excluded = ["page_name", "target_text", "target_href"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { filter, mapKeys } from '@beef/utils';
import { AutoMetricBlockType, AutoMetricEventType } from "../../core";
import { templateParser } from "./helpers";
import { logger } from "../../logger";
export var YaMetricsPublisher = /*#__PURE__*/function () {
  function YaMetricsPublisher(counter) {
    _classCallCheck(this, YaMetricsPublisher);
    this.counter = counter;
  }
  _createClass(YaMetricsPublisher, [{
    key: "handleEvent",
    value: function handleEvent(eventType, context) {
      var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var params = this.flattenContext(context);
      if (target.goal) {
        this.sendGoal(eventType, params, target);
      }
      this.sendParams(eventType, params, target);
    }
  }, {
    key: "flattenContext",
    value: function flattenContext(context) {
      var page = context[AutoMetricBlockType.ROOT],
        section = context[AutoMetricBlockType.SECTION],
        container = context[AutoMetricBlockType.CONTAINER],
        item = context[AutoMetricBlockType.ITEM],
        element = context[AutoMetricBlockType.ELEMENT],
        target = context.target;
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.prefixFields('page', page)), this.prefixFields('section', section)), this.prefixFields('container', container)), this.prefixFields('item', item)), this.prefixFields('element', element)), this.prefixFields('target', target));
    }
  }, {
    key: "formatMetricParams",
    value: function formatMetricParams(eventType, params) {
      var page_name = params.page_name,
        target_text = params.target_text,
        target_href = params.target_href,
        filteredParams = _objectWithoutProperties(params, _excluded);
      switch (eventType) {
        case AutoMetricEventType.CLICK:
          return _defineProperty({}, page_name, _objectSpread(_objectSpread({
            action: eventType
          }, filteredParams), {}, {
            target_text: target_text,
            target_href: target_href
          }));
        case AutoMetricEventType.VIEW:
          return _defineProperty({}, page_name, _objectSpread({
            action: eventType
          }, filteredParams));
        default:
          throw new Error("Unknown event '".concat(eventType, "'"));
      }
    }
  }, {
    key: "prefixFields",
    value: function prefixFields(prefix) {
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return mapKeys(filter(fields, Boolean), function (key) {
        return "".concat(prefix, "_").concat(key);
      });
    }
  }, {
    key: "sendParams",
    value: function sendParams(eventType, params, target) {
      var formattedParams = this.formatMetricParams(eventType, params);
      var elementName = params["".concat(params.target_type, "_name")];
      var targetName = target.name;
      var specificName = eventType === AutoMetricEventType.CLICK ? [elementName, targetName].join(' → ') : elementName || targetName;
      this.counter.sendParamsEvent(formattedParams);
      logger.debug("Sending ".concat(params.target_type, " ").concat(eventType, ": ").concat(specificName), ["\"".concat(Object.keys(formattedParams)[0], "\":"), JSON.stringify(Object.values(formattedParams)[0], null, 2)], [target.element], {
        counterId: this.counter.counterId
      });
    }
  }, {
    key: "sendGoal",
    value: function sendGoal(eventType, params, target) {
      var formattedParams = _objectSpread(_objectSpread({}, params), {}, {
        action: eventType
      });
      var goal = templateParser(target.goal, filter(formattedParams, Boolean));
      this.counter.sendReachGoalEvent(goal);
      logger.debug('Sending reachGoal', ['target', goal], ['element', target.element], {
        counterId: this.counter.counterId
      });
    }
  }]);
  return YaMetricsPublisher;
}();